<template>
  <div v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col w-full mb-2">
            <router-link
              :to="{ path: '/Banners/Create' }"
              class="vs-component vs-button bg_l_green"
              v-has-permission="permission172"
            >
              <feather-icon
                icon="PlusIcon"
                svgClasses="h-4 w-4"
                class="ico"
              />{{ $t("CreateNewBanner") }}
            </router-link>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Version'), sort: 'Version' },
                { title: $t('BannerPosition'), sort: 'BannerPosition' },
                { title: $t('Name'), sort: 'Name' },
                { title: $t('StartDate'), sort: 'StartClock' },
                { title: $t('EndDate'), sort: 'ExpireClock' },
                { title: $t('Priority'), sort: 'Priority' },
                { title: $t('IsActive') },
                { title: $t('Action') }
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 10%">
                  <span v-if="row.pageType == 1">{{ $t("Desktop") }}</span>
                  <span v-if="row.pageType == 2">{{ $t("Mobile") }}</span>
                </td>

                <td style="width: 15%">
                  <span v-if="row.pageType == 1">
                    <span v-if="row.bannerTypeDesktop == 1">{{
                      $t("HomeSlider")
                    }}</span>
                    <span v-if="row.bannerTypeDesktop == 2">{{
                      $t("HomeBottomOfSlider")
                    }}</span>
                    <span v-if="row.bannerTypeDesktop == 3">{{
                      $t("HomeSide")
                    }}</span>
                    <span v-if="row.bannerTypeDesktop == 6">{{
                      $t("HomeHorizontalMiddleSlider")
                    }}</span>
                    <span v-if="row.bannerTypeDesktop == 7">{{
                      $t("HalfOfHomePage")
                    }}</span>
                  </span>
                  <span v-if="row.pageType == 2">
                    <span v-if="row.bannerTypeMobile == 1">{{
                      $t("HomeSlider")
                    }}</span>
                    <span v-if="row.bannerTypeMobile == 2">{{
                      $t("HalfOfHomeTop")
                    }}</span>
                    <span v-if="row.bannerTypeMobile == 3">{{
                      $t("HalfOfHomeBottom")
                    }}</span>
                    <span v-if="row.bannerTypeMobile == 4">{{
                      $t("FullHome")
                    }}</span>
                  </span>
                </td>
                <td style="width: 15%">
                  {{ row.name }}
                </td>
                <td style="width: 12%; direction: ltr">
                  {{ row.startClock }}
                </td>
                <td style="width: 12%; direction: ltr">
                  {{ row.expireClock }}
                </td>
                <td style="width: 8%">
                  {{ row.priority }}
                </td>
                <td style="width: 10%">
                  <vs-checkbox v-model="row.isActive" :disabled="true">{{
                    $t("Active")
                  }}</vs-checkbox>
                </td>
                <td style="width: 15%">
                  <router-link :to="{ path: '/Banners/Modify/' + row.id }">
                    <vs-button
                      radius
                      color="success"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="ml-4 d-inline"
                      v-has-permission="permission171"
                    ></vs-button>
                  </router-link>
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="deleteBanner(row.id)"
                    class="d-inline"
                    v-has-permission="permission170"
                  ></vs-button>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.con-vs-checkbox {
  display: inline-flex;
}
</style>

<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  name: "ContentManagement_Banners_Index",
  components: {
    DataGrid
  },
  data() {
    return {
      permission170: "DeleteBanner",
      permission171: "ModifyBanner",
      permission172: "CreateBanner",
      gridDataSource: {
        type: "app",
        service: "CMS/api/BannersQuery"
      },
      gridSearchData: {
        keyword: ""
      }
    };
  },
  methods: {
    ...mapActions({
      removeBanner: "banner/remove"
    }),
    deleteBanner(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر"
      }).then(result => {
        if (result.value) {
          this.removeBanner(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    }
  }
};
</script>
